import { jsx as _jsx } from "react/jsx-runtime";
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import { ErrorBoundary } from './components/ErrorBoundary';
const container = document.getElementById('root');
if (!container)
    throw new Error('Root element not found');
createRoot(container).render(_jsx(ErrorBoundary, { children: _jsx(App, {}) }));
